// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1FTQc","label":"Labeled_label__Qr4HJ","divider":"Labeled_divider__35-de"};